import { __rest } from "tslib";
import React from "react";
import { Container } from "./styles";
var ToggleButton = function (_a) {
    var value = _a.value, onClick = _a.onClick, handleStyle = _a.handleStyle, _b = _a.activeColor, activeColor = _b === void 0 ? "red" : _b, disabled = _a.disabled, rest = __rest(_a, ["value", "onClick", "handleStyle", "activeColor", "disabled"]);
    return (React.createElement(Container, { style: rest, active: value, customColor: activeColor, disabled: disabled, onClick: function (e) {
            if (!disabled) {
                onClick(!value, e);
            }
        } },
        React.createElement("div", { style: handleStyle })));
};
ToggleButton.defaultProps = {
    value: false,
    onClick: function () { },
    handleStyle: {},
    activeColor: "#2ec9b7",
    disabled: false
};
export default ToggleButton;
//# sourceMappingURL=index.js.map